<div class="page-header" [class.white-mobile]="whiteMobileHeader">
  @if (showBackButton) {
    <div class="page-header__back-button-wrapper" [class.white-mobile]="whiteMobileHeader">
      <button type="button" aria-label="Back" data-testid="page-header-back-btn" class="btn btn-icon" (click)="onBackClick()">
        <i class="icon-back-arrow icon-action-blue" [class.icon-action-blue]="isWebView || whiteMobileHeader" [class.icon-white]="!isWebView && !whiteMobileHeader"></i>
      </button>
    </div>
  }
  <div class="page-header__title"
       data-testid="page-header-title"
       [class.white-mobile]="whiteMobileHeader"
       [class.is-link]="headerIsBackLink"
       (click)="headerIsBackLink && onBackClick()"
       [attr.role]="headerIsBackLink ? 'button' : null"
       [attr.tabindex]="headerIsBackLink ? '0' : null">
    @if (backLabel) {
      <h1 style="margin-bottom: 0;">{{ backLabel }}</h1>
    }
    <!-- title slot -->
    <ng-content select="[header-title]"></ng-content>
  </div>
  <div class="page-header__actions">
    <!-- actions slot -->
    <ng-content select="[header-actions]"></ng-content>
  </div>
</div>
<div class="page-header__divider" [class.white-mobile]="whiteMobileHeader"></div>